import {Injectable} from '@angular/core';

@Injectable()
export class GetMoiService {

  getMoi(moi) {
    moi = '0' + moi;
    if (moi === '1' || moi === '01') {
      if (moi === '01') {
        return 'Jan';
      } else {
        return 'Janvier';
      }
    }
    if (moi === '2' || moi === '02') {
      if (moi === '01') {
        return 'Fév';
      } else {
        return 'Février';
      }
    }
    if (moi === '3' || moi === '03') {
      return 'Mars';
    }
    if (moi === '4' || moi === '04') {
      if (moi === '04') {
        return 'Avr';
      } else {
        return 'Avril';
      }
    }
    if (moi === '5' || moi === '05') {
     return 'Mai';
    }
    if (moi === '6' || moi === '06') {
        return 'Juin';
    }
    if (moi === '7' || moi === '07') {
      if (moi === '07') {
        return 'Juil';
      } else {
        return 'Juillet';
      }
    }
    if (moi === '8' || moi === '08') {
        return 'Août';
    }
    if (moi === '9' || moi === '09') {
      if (moi === '09') {
        return 'Sep';
      } else {
        return 'Septembre';
      }
    }
    if (moi === '10' || moi === '010') {
      if (moi === '010') {
        return 'Oct';
      } else {
        return 'Octobre';
      }
    }
    if (moi === '11' || moi === '011') {
      if (moi === '011') {
        return 'Nov';
      } else {
        return 'Novembre';
      }
    }
    if (moi === '12' || moi === '012') {
      if (moi === '012') {
        return 'Déc';
      } else {
        return 'Décembre';
      }
    }
    return false;
  }

}
